// src/components/artwork/forms/MarketReleaseField.jsx
// Cadence de mise sur le marché d'une œuvre : statut et année prévue (ou réelle). Information de planification, pas une
// décision de vente. Colonnes : artworks.market_release_status, artworks.market_release_year.
import React from "react";
import { useTranslation } from "react-i18next";
import { RELEASE_STATUSES } from "../../../utils/marketRelease";

const DEFAULTS = {
  to_release: "À diffuser", reserved: "Réservée (accord de principe ou option)", withheld: "Retenue", released: "Diffusée",
};
const inputCls = "mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3";

export default function MarketReleaseField({ formData, setFormData, readOnly = false }) {
  const { t } = useTranslation();
  const set = (name, value) => setFormData((prev) => ({ ...(prev || {}), [name]: value }));
  return (
    <div>
      <label htmlFor="market_release_status" className="block text-sm font-medium text-gray-700">
        {t("artworkEdit.marketRelease.title", { defaultValue: "Cadence de mise sur le marché" })}
      </label>
      <div className="grid gap-3 sm:grid-cols-2">
        <select id="market_release_status" value={formData?.market_release_status || ""} disabled={readOnly}
          onChange={(e) => set("market_release_status", e.target.value || null)} className={inputCls}>
          <option value="">{t("artworkEdit.marketRelease.none", { defaultValue: "Non planifiée" })}</option>
          {RELEASE_STATUSES.map((k) => (
            <option key={k} value={k}>{t(`artworkEdit.marketRelease.options.${k}`, { defaultValue: DEFAULTS[k] })}</option>
          ))}
        </select>
        <input id="market_release_year" type="number" min="1900" max="2200" step="1" inputMode="numeric" disabled={readOnly}
          value={formData?.market_release_year ?? ""} onChange={(e) => set("market_release_year", e.target.value || null)}
          placeholder={t("artworkEdit.marketRelease.yearPlaceholder", { defaultValue: "Année (ex. 2027)" })} className={inputCls} />
      </div>
      <p className="mt-1 text-xs text-gray-500">
        {t("artworkEdit.marketRelease.hint", { defaultValue: "Planification interne : ce n'est ni une décision de vente ni une mise en vente." })}
      </p>
    </div>
  );
}
